import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { PaymentProvider } from "../../../../../../../../../../../services/PaymentSystem";
import { ByMulty } from "../../../../../../../../../../../redux/reducers/OrdersPage/interface";
import { StyledColumn } from "../../../../../../../../../../../components/common";
import { getPaymentProviderDisplayName } from "../../../../../../../utils/getPaymentProviderDisplayName";

const Root = styled(StyledColumn)`
	min-width: 450px;
	padding-inline: 24px;
`;

const Content: React.FC<Content.Props> = ({ paymentProviderValue }) => {
	const { t } = useTranslation();

	const _paymentProviderValue = useMemo(
		() => getPaymentProviderDisplayName(paymentProviderValue, t),
		[paymentProviderValue, t],
	);

	return (
		<Root gap="16px">
			{`${
				t("settings.paymentSystems.modal.btns.modalActivate.content") ??
				""
			} ${_paymentProviderValue}?`}
		</Root>
	);
};

declare namespace Content {
	interface Value extends ByMulty {}

	interface Props {
		paymentProviderValue: PaymentProvider;
	}
}

export default Content;
